<template>
  <div style="display: flex;flex-wrap: wrap">
    <div class="card" v-for="(car,index) in carList" :key="index" @click="openModule(index,car)">
      <!--    <a :href="user.html_url" target="_blank">-->
      <img :src="car.imgone" style='width: 200px'/>
      <!--    </a>-->
      <p class="card-text">{{car.fullname}}</p>
    </div>

    <el-dialog title="车辆信息" :visible.sync="dialogFormVisible">
      <el-form :model="car">
        <el-result icon="success" title="已上架" subTitle="" v-if="car.state === 0"/>
        <el-result icon="warning" title="被预定" subTitle="" v-if="car.state === 2"/>
        <el-result icon="error" title="已下架" subTitle="" v-if="car.state === -1"/>
        <el-result icon="info" title="待审核" subTitle="" v-if="car.state === 1"/>
        <el-form-item label="汽车名称:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.fullname}}</span>
        </el-form-item>
        <el-form-item label="汽车品牌:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.brandinfo}}</span>
        </el-form-item>
        <el-form-item label="汽车类型:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.category}}</span>
        </el-form-item>
        <el-form-item label="行驶里程:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.distance}}</span>
        </el-form-item>
        <el-form-item label="过户信息:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.ownernum}}</span>
        </el-form-item>
        <el-form-item label="变速箱类型:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.gearbox}}</span>
        </el-form-item>
        <el-form-item label="汽车排量:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.displacement}} T/L</span>
        </el-form-item>
        <el-form-item label="颜色:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.color}}</span>
        </el-form-item>
        <el-form-item label="期望售价:" :label-width="formLabelWidth" class="item_show">
          <span>{{car.price/1000000}}万元</span>
        </el-form-item>
        <el-form-item label="车辆照片1:" :label-width="formLabelWidth" class="item_show" v-if="car.imgone">
          <img :src="car.imgone" alt="">
        </el-form-item>
        <el-form-item label="车辆照片2:" :label-width="formLabelWidth" class="item_show" v-if="car.imgtwo">
          <img :src="car.imgtwo" alt="">
        </el-form-item>
        <el-form-item label="车辆照片3:" :label-width="formLabelWidth" class="item_show" v-if="car.imgthree">
          <img :src="car.imgthree" alt="">
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <!--        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
        <el-button type="danger" @click="openStop(car.id)" v-if="car.state === 0">下 架</el-button>
        <el-button type="primary" @click="changeCarSell(car.id)" v-else-if="car.state === -1">修 改</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
export default {
  name: "MyCar",
  data(){
    return{
      carList: [],
      dialogFormVisible: false,
      car:{},
      formLabelWidth: '120px'
    }
  },
  created() {
    var userid = this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.id :''
    this.axios.get('/car/getMyCarList/' + userid + '').then(res => {
      if(res.data.code == 0){
        this.carList = res.data.data.carList
      }else {
        this.$message.error("系统错误")
      }
    })
  },
  methods:{
    openModule(index,car){
      this.dialogFormVisible = true
      this.car = car
    },
    stopSell(carId){
      console.log('下架' + carId)
      this.axios.get('/car/stopSell/' + carId + '').then(res=>{
        if(res.data.code === 0){
          this.$message({
            type: 'success',
            message: '已下架!'
          });
          this.carList = res.data.data.carList
          this.dialogFormVisible = false
        }
      })
    },
    changeCarSell(carId){
      console.log('修改已被下架商品' + carId)
      this.$router.push({path:'/index/change',query:{carid:carId}});
    },
    openStop(carId) {
      this.$confirm('此操作将下架该汽车,再次上架需审核, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopSell(carId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  }
}
</script>

<style scoped>
.card {
  float: left;
  width: 30%;
  padding: .75rem;
  margin-bottom: 2rem;
  border: 1px solid #efefef;
  text-align: center;
  cursor: pointer;
}
.card-text {
  font-size: 85%;
}

.item_show {
  display: inline-block;
}
.item_show >>> img {
  width: 100px;
  height: 100px;
}
</style>